export function initNavbarMobileMenu() {
    const nav = document.querySelector('.js-navbar');
    const toggle = document.querySelector('.js-navbarMobileToggle');
    const menu = document.querySelector('.js-navbarMobileMenu');

    if (!nav || !toggle || !menu) return;

    const icon = toggle.querySelector('i');
    let scrollY = 0;

    const setMenuTop = () => {
        menu.style.top = `${nav.offsetHeight - 1}px`;
        menu.style.maxHeight = `calc(100vh - ${nav.offsetHeight}px)`;
    };

    const setIcon = open => {
        if (!icon) return;

        icon.classList.toggle('fa-bars', !open);
        icon.classList.toggle('fa-times', open);
    };

    const setOpen = open => {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Sluit menu' : 'Open menu');
        menu.classList.toggle('is-open', open);

        if (open) {
            scrollY = window.scrollY || window.pageYOffset || 0;
            document.body.style.top = `-${scrollY}px`;
            document.body.classList.add('nav-mobile-open');
        } else {
            document.body.classList.remove('nav-mobile-open');
            document.body.style.top = '';
            window.scrollTo(0, scrollY);
        }

        setIcon(open);
    };

    const isOpen = () => menu.classList.contains('is-open');

    const mdQuery = window.matchMedia('(min-width: 768px)');

    const handleResize = () => {
        setMenuTop();
        if (mdQuery.matches && isOpen()) {
            setOpen(false);
        }
    };

    setMenuTop();
    window.addEventListener('resize', handleResize);

    toggle.addEventListener('click', () => {
        setMenuTop();
        setOpen(!isOpen());
    });

    document.addEventListener('click', e => {
        if (!isOpen()) return;
        const target = e.target;
        if (!(target instanceof Node)) return;
        if (!nav.contains(target) && !menu.contains(target)) setOpen(false);
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    menu.addEventListener('click', e => {
        const target = e.target;
        if (!(target instanceof Node)) return;
        const clickedLink = target.closest ? target.closest('a') : null;
        if (clickedLink) setOpen(false);
    });

    setOpen(false);
}
